import getIconSize from './get-icon-size.js';
export default getIconSize;
export { getIconSize };
//# sourceMappingURL=index.js.map